import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=3f02b200&scoped=true"
import script from "./app-main.vue?vue&type=script&lang=js"
export * from "./app-main.vue?vue&type=script&lang=js"
import style0 from "./app-main.vue?vue&type=style&index=0&id=3f02b200&prod&lang=scss&scoped=true"
import style1 from "./app-main.vue?vue&type=style&index=1&id=3f02b200&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02b200",
  null
  
)

export default component.exports